import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService, UserSession } from './auth.service';

@Injectable({
	providedIn: 'root',
})
export class UserSessionService {
	private subscription?: Subscription;
	private value: UserSession = {};

	get userSession(): UserSession {
		return this.value;
	}

	constructor(private readonly authService: AuthService) {
		this.subscription = this.authService.userSession().subscribe((it) => {
			this.value = it;
		});
	}
}
